import React, {ReactNode} from "react";
import {Survey, SurveyPaymentMethod} from "../../models/survey";
import {currencySymbol} from "../../utility/utility";
import {UrlMetadata} from "../../hooks/capture-metadata/use-capture-metadata";

export function IntroIncentiveDetails({
	survey,
	metadata,
}: Readonly<{survey: Survey; metadata: UrlMetadata | null}>): ReactNode {
	// When redirected from the respondent, do not display the incentive.
	if (
		(metadata?.respondent_profile_id && metadata?.respondent_profile_id !== "") ||
		(metadata?.respondent_user_id && metadata?.respondent_user_id !== "") ||
		(metadata?.respondent_project_id && metadata?.respondent_project_id !== "") ||
		(metadata?.respondent_screener_response_id && metadata?.respondent_screener_response_id !== "")
	) {
		return null;
	}

	// If the logged-in user is in the "Vurvey Creators" or "Mailing List" group with a custom incentive, display the custom incentive (Payment Method: Incentive).
	if (
		survey.userRequestingSurveyInviteGroup?.paymentMethod?.toLowerCase() ===
			SurveyPaymentMethod.INCENTIVE.toLowerCase() &&
		survey.userRequestingSurveyInviteGroup.incentiveAmount !== null &&
		Number(survey.userRequestingSurveyInviteGroup.incentiveAmount) > 0 &&
		survey.userRequestingSurveyInviteGroup.incentiveCurrency
	) {
		return (
			<span>
				$$ Incentive: {currencySymbol(survey.userRequestingSurveyInviteGroup.incentiveCurrency)}
				{survey.userRequestingSurveyInviteGroup.incentiveAmount}
			</span>
		);
	}

	// If the logged-in user is in the "Vurvey Creators" or "Mailing List" group with a custom incentive, do not display anything (Payment Method: Credits).
	if (
		survey.userRequestingSurveyInviteGroup?.paymentMethod?.toLowerCase() === SurveyPaymentMethod.CREDITS.toLowerCase()
	) {
		return null;
	}

	// Without a Custom Incentive Group, do not display the incentive if the payment method is set to "Credits."
	if (survey.paymentMethod.toLowerCase() === SurveyPaymentMethod.CREDITS.toLowerCase()) {
		return null;
	}

	// If the payment method is set to "Incentive" and we are not redirected from the respondent, then display the incentive.
	if (survey.incentiveAmount === undefined || Number(survey.incentiveAmount) <= 0) {
		return null;
	}

	return (
		<span>
			$$ Incentive: {currencySymbol(survey.incentiveCurrency)}
			{survey.incentiveAmount}
		</span>
	);
}
